module.exports = __webpack_public_path__ + "img/WE_blog6.46c4c670.png";